module.exports = __webpack_public_path__ + "4c3d52e7a9e0f41b81a9cd258c29b94b.png";